<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Quản lý gói dịch vụ</div>
      </div>
      <div class="card card-w-title">
        <div class="list-data">
          <div class="list-title">
            <span class="p-m-0">Danh sách gói dịch vụ</span>
            <span class="p-input-icon-left" v-if="checkVisible('service_park', 'add')">
              <Button
              :label="'Tạo mới'"
                type="button"
                v-on:click="onActionClicked({action: {name: 'add', label: 'Tạo mới'}, key: 'add'})"
              > </Button>
            </span>
          </div>
          <BaseCommon v-if="dataModel && checkVisible('service_park', 'list')"
            :key="componentKey"
            :listData="listData"
            :model="dataModel"
            :filterDefault="filters"
            v-on:action-click="onActionClicked"
            :actions="getRowActions()"
          ></BaseCommon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import BaseCommon from '../common'
export default {
  components: {
    BaseCommon
  },
  data() {
    return {
      filters: {},
      listData: [],
      dataModel: null,
      componentKey: 0
    }
  },
  mounted () {
    this.initData();
  },
  created () {
    if(this.$route.params.reload) {
      window.location.reload();
    }
  },
  watch: {
    '$route': 'initData'
  },
  methods: {
    initData() {
      setTimeout(async () => {
        //if (this.checkVisible('service_park', 'list')) {
          await this.initParams();
        //}
      }, 1000);
    },
    checkVisible(groupName, action) {
      return this.$myConstants.checkVisible(this.$store.getters.permission, groupName, action);
    },
    async initParams() {
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      this.modelName = 'service_park';
      var variables = {
        where_key: {
          status: {'_in': [0, 1] }
        },
        orderBy: {
          id: 'desc',
        }
      }
      var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      this.dataModel = DataServices.getModel(this.modelName);
      this.dataModel.processData(list);
      this.listData = list;
      this.componentKey++;
      this.$store.commit('setLoading', false);
    },
    onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        case 'add':
          if(this.checkVisible('service_park', 'add')) {
            this.$router.push({path: '/admin/service-park/function'});
          }
          break;
        case 'edit':
          if(this.checkVisible('service_park', 'edit')) {
            if (data && Object.keys(data).length) {
              this.$router.push({path: '/admin/service-park/function/' + data.data.id});
            }
          }
          break;
      }
    },
    getRowActions() {
      var organization = this.$myConstants.organizationUserLogin();
      var creator_organization_id = (!this.$myConstants.isEmpty(organization.id)) ? organization.id:null;
      var actions = {}
      var that = this;
      actions.filter = { name: 'clear', icon: 'times-circle'};
      actions.rows = function (rowData) {
        var buttons = {}
        if(that.checkVisible('service_park', 'edit')) {
          if (creator_organization_id == rowData.creator_organization_id) {
            buttons.edit = {name: 'edit', icon: 'pencil', key: 'id', path: `admin/service-park/edit`}
            if (that.dataModel.actions) {
              var modelaction = that.dataModel.actions(rowData)
              Object.assign(buttons, modelaction);
            }
          }
        }
        return buttons
      }
      return actions
    },
    cancelFilter() {
      this.filters = {};
    }
  }
}
</script>
<style lang="scss">
.box-filters{ margin: 15px 0;
  .p-formgroup-inline { display: flex;flex-wrap: wrap; align-items: flex-start;
    .p-field{ margin-right: 50px; margin-bottom: 15px;
      &:last-child{margin: 0; position: relative;}
      label{display: block;}
      .p-dropdown, input{width: 230px;}
      .btn-cancel{width: 90px;position: absolute; top: 30px;}
    }
  }
}
.external-link{ color: #0066FF; cursor: pointer;
  &.black-color {
    span{color: #000;}
  }
  span{color: #199ED8;}
}
</style>